<div class="container-fluid">
  <div class="row mt-md-3 mt-0 ml-lg-1 ">
    <div class="col col-md mb-2 home-responsive">
      <div class="home-card" style="background-image: url('./assets/images/live tv.png')" routerLink="/livetv"></div>
      <div class="head">
        <div class="live-head text-white cursor-pointer" routerLink="/livetv">{{'NAV.NAV3' | translate}}</div>
      </div>
    </div>
    <div class="col col-md mb-2  home-responsive">
      <div class="home-card" style="background-image: url('./assets/images/new_icons/movies.png')" routerLink="/movies"></div>
      <div class="head">
        <div class="live-head text-white cursor-pointer" routerLink="/movies">{{'NAV.NAV4' | translate}}</div>
      </div>
    </div>
    <div class="col col-md mb-2  home-responsive">
      <div class="home-card" style="background-image: url('./assets/images/new_icons/series.png')" routerLink="/series"></div>
      <div class="head">
        <div class="live-head text-white cursor-pointer"  routerLink="/series">{{'NAV.NAV5' | translate}}</div>
      </div>
    </div>
    <div class="col col-md mb-2  home-responsive">
      <div class="home-card" style="background-image: url('./assets/images/settings (1).png')" routerLink="/settings">
        <div class="head">
          <div class="live-head text-white cursor-pointer" routerLink="/settings">{{'HOME.SETTINGS' | translate}}</div>
        </div>
      </div>

    </div>
    <div class="col col-md mb-2  home-responsive" >
      <div class="home-card" style="background-image: url('./assets/images/search (1).png')" routerLink="/search"></div>
      <div class="head">
        <div class="live-head text-white cursor-pointer" routerLink="/search" >{{'NAV.NAV1' | translate}}</div>
      </div>

    </div>
    
  </div>
 
  <div class="row mx-md-1 mt-3">
    <div class="col-12">
      <h5 class="mr-auto">{{'NAV.NAV4' | translate}}</h5>
      <ngx-slick-carousel class="carousel custom-slider" #slickModal="slick-carousel" [config]="slideConfig">
        <div ngxSlickItem *ngFor="let select of movieShowList let i=index;" class="slide">
          <div class="imageContainer-search position-relative" style="max-height: 320px;" [routerLink]="['/movies/info/'+select.stream_id]" [queryParams]="{movieBy: 'search'}">
            <img class="search-imgm cursor-pointer" [src]="select.stream_icon" alt="{{select.name}}" loading=lazy >
            <p class="search-title text-left mt-1" title="{{select.name}}">{{select.name}}</p>
          </div>
        </div>
        <div class="slide d-flex justify-content-center" *ngIf="loadMovies">
          <div class="d-flex justify-content-center align-item-center cursor-pointer" (click)="loadMovie()" *ngIf="!isLoading ">
             <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16">
              <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"/>
              <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"/>
            </svg>
          </div>
          <div *ngIf="isLoading" class="spinner-border spinner-border-lg fs-34" style="vertical-align:middle;" role="status">
        </div>
        </div>
      </ngx-slick-carousel>
    </div>
  </div>
  <div class="row  mx-md-1 mt-3">
    <div class="col-12 text-left d-flex">
      <h5 class="">{{'NAV.NAV5' | translate}}</h5>
      <!-- <div class="spinner-border spinner-border-sm mt-2 mr-2 ml-3 " role="status" *ngIf="isLoading">
        <span class="sr-only">{{ 'COMMON.LOADING' | translate }}</span>
      </div> -->
    </div>
    <div class="col-12">
      <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
          <div ngxSlickItem *ngFor="let select of selectedcategory let i=index;" class="slide">
          <!-- <div class="pr-0">
            <div class="pr-md-3 pr-1 cursor-pointer" [routerLink]="['/series/info/'+select.series_id]"> -->
              <div class="imageContainer-search pr-3 position-relative" [routerLink]="['/series/info/'+select.series_id]">
                <!-- pr-md-3 pr-2 -->
                <img class="search-imgs" [src]="select.cover" alt="First slide"  loading=lazy>
                <p class="search-title text-left mt-1" title="{{select.name}}">{{select.name}}</p>
              </div>
           </div>
           <div class="slide d-flex justify-content-center" *ngIf="loadSeries">
            <div class="d-flex justify-content-center align-item-center cursor-pointer" (click)="loadSeriesData()" *ngIf="!isLoading ">
               <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16">
                <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"/>
                <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"/>
              </svg>
            </div>
            <div *ngIf="isLoading" class="spinner-border spinner-border-lg fs-34" style="vertical-align:middle;" role="status"></div>
          </div>
      </ngx-slick-carousel>
    </div>
  </div>
  
</div>
